import { FieldPath } from '@onepercentio/one-ui/type-utils'
import { GetFieldType } from 'lodash'
import get from 'lodash/get'
import { createContext, PropsWithChildren, useContext, useState } from 'react'

export enum HomeHeadingDisplayModel {
  /** This displays the default banner for the tenant */
  BANNER,
  /** This displays the promotional banner */
  PROMO,
}

/**
 * Defines how the approval will be done
 */
export enum OfferConfirmationType {
  /** Manually approve each operation */
  MULTI_STEP,
  /** Automatically approve each operation */
  AUTO,
}

export type DisplayModelsContextShape = {
  home: {
    heading: HomeHeadingDisplayModel
  }
  offerConfirmation: {
    mode: OfferConfirmationType
  }
}

export const InitialDisplayModel = {
  home: {
    heading: HomeHeadingDisplayModel.BANNER,
  },
  offerConfirmation: {
    mode: process.env.REACT_APP_OFFER_CONFIRMATION_MODEL
      ? OfferConfirmationType[
          process.env
            .REACT_APP_OFFER_CONFIRMATION_MODEL as unknown as keyof typeof OfferConfirmationType
        ]
      : OfferConfirmationType.MULTI_STEP,
  },
}

export const DisplayModelContext = createContext<DisplayModelsContextShape>(
  null as any
)

/**
 * The purpose of this context, is to provide a way to easily toggle display models of UI elements
 */
export default function DisplayModelsProvider({
  children,
}: PropsWithChildren<{}>) {
  const [displayModel, _setDisplayModel] = useState<DisplayModelsContextShape>(
    () => InitialDisplayModel
  )

  return (
    <DisplayModelContext.Provider value={displayModel}>
      {children}
    </DisplayModelContext.Provider>
  )
}

export function useDisplayModel<P extends FieldPath<DisplayModelsContextShape>>(
  model: P
): GetFieldType<DisplayModelsContextShape, P> {
  const ctx = useContext(DisplayModelContext)
  return get(ctx, model)
}
